"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[9717],{

/***/ 1101:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ BrandsRow_BrandsRow)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./src/hooks/useScrollingFrame.ts
var useScrollingFrame = __webpack_require__(63141);
// EXTERNAL MODULE: ./local_modules/intersection-observer/useEntry.ts
var useEntry = __webpack_require__(34886);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./src/components/layout/WidthContainer/WidthContainer.tsx
var WidthContainer = __webpack_require__(59343);
// EXTERNAL MODULE: ./src/components/dataDisplay/Image/Image.tsx + 5 modules
var Image = __webpack_require__(76884);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(78565);
;// CONCATENATED MODULE: ./src/pages/landing/View/components/BrandsRow/messages.ts
/* harmony default export */ const messages = ({
    text: {
        en: "And many more luxury brands to choose from."
    }
});

;// CONCATENATED MODULE: ./src/pages/landing/View/components/BrandsRow/images/brands.png
const brands_namespaceObject = __webpack_require__.p + "images/brands_9200d8.png";
;// CONCATENATED MODULE: ./src/pages/landing/View/components/BrandsRow/images/brands.png?src-loader

/* harmony default export */ const brandssrc_loader = ({ src: brands_namespaceObject, aspect: 50.7273, width: 3348, height: 66 });
;// CONCATENATED MODULE: ./src/pages/landing/View/components/BrandsRow/BrandsRow.tsx









const MobileView = ()=>{
    const [ref, entry] = (0,useEntry/* default */.Z)();
    const isVisible = entry === null || entry === void 0 ? void 0 : entry.isIntersecting;
    const imageRef = (0,useScrollingFrame/* default */.Z)({
        horizontalOffset: 16,
        verticalOffset: 16,
        isVisible
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        ref: ref,
        className: "mt-24",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative overflow-hidden pt-24",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: imageRef,
                    className: "absolute left-0 top-0 mx-16 w-[1116rem]",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        className: "w-full",
                        src: brandssrc_loader,
                        width: 1116,
                        alt: "Brands"
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-24 text-center",
                message: messages.text,
                style: "p3"
            })
        ]
    });
};
const BrandsRow = ()=>{
    const { isMobile } = (0,useDevice/* default */.Z)();
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(MobileView, {});
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(WidthContainer/* default */.Z, {
        className: "mt-32 text-center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                className: "w-full",
                src: brandssrc_loader,
                width: 1136,
                alt: "Brands"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                className: "mt-32",
                message: messages.text,
                style: "p1"
            })
        ]
    });
};
/* harmony default export */ const BrandsRow_BrandsRow = (BrandsRow);


/***/ })

}]);